import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { ToxnotServiceClient } from '../../store/ToxnotServiceClient';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import TowStarter, { DataSourceOptionType } from '../../tow/TowStarter';

import './styles.css';
import { Link } from 'react-router-dom';
import { BomTemplatesManager } from '../../store/Managers/BomTemplatesManager';
import { data } from 'jquery';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { TeamRole } from '../../store/Models/UserContext';

interface StartPassportState {
    towOption: DataSourceOptionType | null;
}

class StartPassport extends ToxnotSignInRequiredComponent<ToxnotComponentProperties, StartPassportState> {
    private _towStarter: TowStarter;

    // ===============================================================================

    public constructor(props: ToxnotComponentProperties) {
        super(props);

        this.state = {
            towOption: null
        };

        this._towStarter = new TowStarter();
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    public renderConcreteComponent() {
        return (
            <div id="start-report-content" className="start-content">
                <div className="full-content">
                    <div className="start-subcontent-heading">
                        {this.localizeString("Share Passports on the Passport Library")}
                    </div>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("You can securely share your material data with your customers by publishing a Material Passport on the Passport Library.")}<br />
                    </p>
                    <div className="start-subcontent-content-container">
                        <ul>
                            <li>{this.localizeString("Easily manage customer access to your data")}</li>
                            <li>{this.localizeString("Use your Company Page to promote your Passports")}</li>
                            <li>{this.localizeString("Protect proprietary IP")}</li>
                        </ul>
                    </div>
                    <p className="start-subcontent-content-container">
                        <Link to="/Exchange" target="_blank">{this.localizeString("Check out existing Passports on the Passport Library")}</Link>
                        {" "}{this.localizeString("or")}{" "}
                        <a href="https://content.toxnot.com/toxnot-exchange" target="_blank">{this.localizeString("Learn More about the Passport Library here")}</a>.
                    </p>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("Do you have an existing Product or Material in 3E Exchange, or do you need to import data?")}
                    </p>
                    <div className="form-group start-subcontent-content-container">
                        <div className="radio">
                            <label>
                                <input type="radio" name="importOrSelectRadio" checked={this.state.towOption === DataSourceOptionType.SelectSingle} onChange={e => this.setState({ towOption: DataSourceOptionType.SelectSingle })} /> {this.localizeString("Select an existing Product/Material from my Library")}
                            </label>
                        </div>
                        <div className="radio">
                            <label>
                                <input type="radio" name="importOrSelectRadio" checked={this.state.towOption === DataSourceOptionType.SelectMultiple} onChange={e => this.setState({ towOption: DataSourceOptionType.SelectMultiple })} /> {this.localizeString("Select multiple Products/Materials from my Library")}
                            </label>
                        </div>
                        {(this.props.appServices.userContext!.role !== TeamRole.Marketing) &&
                            <div className="radio">
                                <label>
                                    <input type="radio" name="importOrSelectRadio" checked={this.state.towOption === DataSourceOptionType.Import} onChange={e => this.setState({ towOption: DataSourceOptionType.Import })} /> {this.localizeString("Import a Product or Material")}
                                </label>
                            </div>
                        }
                    </div>
                    <div className="start-subcontent-content-container">
                        {(this.state.towOption === DataSourceOptionType.Import) &&
                            <div className="dropdown">
                                <button className="btn btn-default dropdown-toggle" type="button" id="bom-templates" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                    {this.localizeString("Download Import Template")} <span className="caret"></span>
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="bom-templates">
                                    {BomTemplatesManager.getStandardBomImportTemplate(this.props.appServices).map((t, i) => (
                                        <li key={i}><a href={`/files/BomTemplates/${t.filename}`}>{t.localizedDescription}</a></li>
                                    ))}
                                </ul>
                            </div>
                        }
                    </div>
                    <p className="start-subcontent-content-container">
                        {(this.state.towOption !== null) &&
                            <button type="button" className="btn btn-toxnot-complement" onClick={async (e) => await this.startWorkflowButton_click()}>{this.localizeString("Start Workflow")} <span className="glyphicon glyphicon-chevron-right"></span></button>
                        }
                    </p>
                    <div id="scroll-end-target"></div>
                </div>
            </div>
        );
    }

    // ===============================================================================

    private startWorkflowButton_click = async () => {
        this.props.appServices.trackEvent("get-started-start-publish-passport-workflow-clicked");

        const success = await this._towStarter.startPublishSmWorkflow(this.state.towOption!);

        if (!success) {
            this.props.appServices.displayApiErrorMessage();
        }
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices })
)(StartPassport as any);
